import Router from '@/Router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider as JotaiProvider } from 'jotai';
import { useTranslation } from 'react-i18next';
import { I18nProvider } from '@eye-able/ui/providers/I18nProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (retryCount, error) => {
        const status = error?.status;

        // Check if the error is an instance of an Error and has a status of 401 (unauthorized) or 404 (not found)
        if (status === 401 || status === 404) {
          // Do not retry
          //console.log('Do not retry for 401 or 404 errors');
          return false;
        }
        //retry up to 2 times for all other types of errors
        return retryCount < 2;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: 1000 * 60 * 60 * 4, // 4 hours
      refetchInterval: 1000 * 60 * 60 * 4, // 4 hours
      staleTime: 1000 * 60 * 60 * 4, // 4 hours
      cacheTime: 1000 * 60 * 60 * 4, // 4 hours
    },
  },
});

function App() {
  const { i18n } = useTranslation();

  return (
    <QueryClientProvider client={queryClient}>
      <JotaiProvider>
        <I18nProvider i18n={i18n}>
          <Router />
        </I18nProvider>
      </JotaiProvider>
    </QueryClientProvider>
  );
}

export default App;
